'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { rememberOfflineShellPath } from '@/lib/offline-shell-snapshot';

/**
 * While online, remember a few safe routes so the offline page can offer them.
 */
export default function OfflineShellTracker() {
  const pathname = usePathname();

  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (!navigator.onLine) return;
    rememberOfflineShellPath(pathname);
  }, [pathname]);

  return null;
}
